<template>
  <div id="tags-view-container" class="tags-view-container">
    <keep-alive>
      <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
        <router-link
          v-for="tag in visitedViews"
          :key="tag.path"
          ref="tag"
          :class="isActive(tag)?'active':''"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          class="tags-view-item"
          tag="span"
          @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
          @contextmenu.prevent.native="openMenu(tag,$event)"
        >
          {{ generateTitle(tag.title) }}
          <span
            v-if="!isAffix(tag)"
            class="el-icon-close"
            role="button"
            tabindex="0"
            aria-label="关闭标签"
            @click.prevent.stop="closeSelectedTag(tag)"
            @keydown.enter.prevent.stop="closeSelectedTag(tag)"
            @keydown.space.prevent.stop="closeSelectedTag(tag)"
          />
        </router-link>
      </scroll-pane>
    </keep-alive>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <!-- <li @click="refreshSelectedTag(selectedTag)">刷新</li>-->
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他标签</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane';
import { generateTitle } from '@/utils/i18n';

export default {

  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    };
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    },
    routes() {
      return this.$store.state.permission.routes;
    },
    ScanBaggings() {
      return this.$store.state.tagsView.ScanBaggings;
    }
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    },
    visitedViews: {
      handler(newVal, oldVal) {
        this.$store.dispatch('tagsView/upDataViewCachedList', newVal);
      }
    }
    // visitedViews() { // 判断是否是最后一个标签
    // console.log('查询当前标签——visitedViews', this.visitedViews, this.visitedViews.length);
    // }
  },
  mounted() {
    this.initTags();
    this.addTags();
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path;
    },
    isAffix(tag) {
      const { meta } = tag;
      return meta && meta.affix;
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = [];
      routes.forEach(route => {
        const { meta, path, name, children } = route;
        if (meta && meta.affix) {
          const tagPath = path.resolve(basePath, path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: name,
            meta: { ...meta }
          });
        }
        if (children) {
          const tempTags = this.filterAffixTags(children, path);
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags];
          }
        }
      });
      return tags;
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes);
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag);
        }
      }
    },
    addTags() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route);
      }
      return false;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag);
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route);
            }
            break;
          }
        }
      });
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          });
        });
      });
    },
    closeSelectedTag(view) {
      // console.log('是否禁点——visitedViews', this.visitedViews.length <= 1 ? '是' : '否');
      if (this.visitedViews.length <= 1) {
        console.log('1');
      } else {
        this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
          if (this.isActive(view)) {
            if (view.title === 'dashboard') {
              return;
            }
            this.toLastView(visitedViews, view);
          }
        });
      }
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag);
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return;
        }
        this.toLastView(visitedViews, view);
      });
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath });
        } else {
          this.$router.push('/');
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    handleScroll() {
      this.closeMenu();
    },

    generateTitle
  }
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 40px;
  width: 100%;
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid #e5e6eb;
  box-shadow: 0 6px 18px rgba(29, 33, 41, 0.035);
  backdrop-filter: saturate(140%) blur(10px);

  .tags-view-wrapper {
    display: flex;
    align-items: center;
    height: 100%;

    .tags-view-item {
      display: inline-flex;
      align-items: center;
      flex: 0 0 auto;
      position: relative;
      cursor: pointer;
      height: 28px;
      line-height: 1;
      border: 1px solid #e5e6eb;
      border-radius: 8px;
      color: #4e5969;
      background: #f7f8fa;
      padding: 0 10px;
      font-size: 12px;
      margin-left: 6px;
      transition: all 0.2s ease;

      &:first-of-type {
        margin-left: 20px;
      }

      &:last-of-type {
        margin-right: 20px;
      }

      &:hover {
        border-color: #cfead9;
        background: #f2fbf6;
        color: #00a551;
        box-shadow: 0 6px 14px rgba(0, 165, 81, 0.08);
      }

      &.active {
        background: linear-gradient(135deg, #00a551, #12b866);
        color: #fff;
        border-color: #00a551;
        box-shadow: 0 8px 18px rgba(0, 165, 81, 0.18);

        &::before {
          content: '';
          background: rgba(255, 255, 255, 0.92);
          display: inline-block;
          flex: none;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          position: relative;
          margin-right: 6px;
          vertical-align: middle;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .tags-view-wrapper {
      .tags-view-item {
        height: 26px;
        line-height: 26px;
        padding: 0 8px;
        margin-left: 4px;
        border-radius: 7px;

        &:first-of-type {
          margin-left: 10px;
        }

        &:last-of-type {
          margin-right: 10px;
        }
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 6px;
    border: 1px solid #e8eeeb;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 400;
    color: #4e5969;
    box-shadow: 0 18px 40px rgba(17, 24, 39, 0.12);

    li {
      margin: 0;
      padding: 9px 18px;
      cursor: pointer;
      border-radius: 8px;
      white-space: nowrap;
      transition: all 0.2s ease;

      &:hover {
        background: #f2fbf6;
        color: #00a551;
      }

      & + li {
        margin-top: 2px;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: none;
      width: 16px;
      height: 16px;
      line-height: 16px;
      margin-left: 6px;
      vertical-align: middle;
      border-radius: 50%;
      text-align: center;
      color: #86909c;
      cursor: pointer;
      outline: none;
      position: relative;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      &:before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0.65);
        transform-origin: center;
        display: block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        color: inherit;
        font-size: 12px;
        vertical-align: baseline;
      }

      &:hover,
      &:focus,
      &:focus-visible {
        background-color: #00a551;
        color: #fff;
        box-shadow: 0 0 0 2px rgba(0, 165, 81, 0.16);
      }

      &:active {
        background-color: #008c45;
        color: #fff;
      }
    }

    &.active {
      .el-icon-close {
        color: #fff !important;
        background-color: rgba(255, 255, 255, 0.22);

        &:hover,
        &:focus,
        &:focus-visible {
          background-color: rgba(255, 255, 255, 0.3);
          color: #fff;
          box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
        }

        &:active {
          background-color: rgba(255, 255, 255, 0.38);
          color: #fff;
        }
      }
    }
  }
}
</style>
